import React from 'react';
import { NavLink } from 'react-router-dom';

const focus = {
    title: 'FOCUS',
    flaticon: 'flaticon-focus',
    description: 'To drive growth through strategic land acquisitions, transparent processes, and world-class project management that deliver trust and confidence at every stage.'
};

const services = [
    {
        title: 'Infrastructure',
        flaticon: 'flaticon-city',
        description: 'Delivering large-scale, high-quality projects with precision, strategic planning, and timely execution.'
    },
    {
        title: 'Real Estate',
        flaticon: 'flaticon-paint',
        description: 'Developing premium townships, villa communities, and sustainable layouts across key growth corridors.'
    },
    {
        title: 'Innovation',
        flaticon: 'flaticon-bulb',
        description: 'Adopting modern engineering, advanced technology, and future-ready development practices.'
    },
    {
        title: 'Sustainability',
        flaticon: 'flaticon-recycle',
        description: 'Creating eco-friendly communities with responsible land use, abundant green spaces, and long-term environmental care.'
    },
    {
        title: 'Governance',
        flaticon: 'flaticon-users',
        description: 'Ensuring strong systems, transparent processes, & visionary project management across all operations.'
    },
    {
        title: 'Own Machinery',
        flaticon: 'flaticon-crane',
        description: 'To strengthen the org with fully owned machinery, integrated team execution, efficient project management ensuring faster, timely delivery, superior quality & operational control.'
    },
    {
        title: 'Customer Trust',
        flaticon: 'flaticon-support',
        description: 'Building long-term customer relationships through integrity, clarity, and the consistent delivery of promised quality.'
    }
];

var img1 = require('./../../images/background/bg-5.png');
var img2 = require('./../../images/background/line.png');

class OurServices3 extends React.Component {
    componentDidMount(){
        function loadScript(src) {
           
          return new Promise(function(resolve, reject){
            var script = document.createElement('script');
            script.src = src;
            script.addEventListener('load', function () {
              resolve();
            });
            script.addEventListener('error', function (e) {
              reject(e);
            });
            document.body.appendChild(script);
            document.body.removeChild(script);
          })
        };
 
      loadScript('./assets/js/masonary.js');
      
    };
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-white mobile-page-padding" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head">
                            <div className="mt-separator-outer separator-center">
                                <div className="mt-separator">
                                    <h2 className="text-uppercase sep-line-one ">{focus.title}</h2>
                                        <p className="m-t10">{focus.description}</p>
                                </div>
                            </div>
                        </div>
                        {/* TITLE END */}
                        {/* IMAGE CAROUSEL START */}
                      
                        <div className="section-content">
                            <div className="row">
                            {services.map((item, index) => (
                                <div key={index} className="col-md-4 col-sm-6">
                                    <div className="mt-icon-box-wraper p-a30 center m-b30 box-shadow bg-white service4box">
                                        <div className="mt-icon-box-sm inline-icon text-primary  m-b20 radius bg-primary  scale-in-center bg-moving" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                            <span className="icon-cell text-secondry"><i className={item.flaticon} /></span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="mt-tilte text-uppercase font-weight-600 m-b20">{item.title}</h4>
                                            <p>{item.description}</p>
                                            {/* <NavLink to={"/services"} className="site-button-link" data-hover="Read More">Read More <i className="fa fa-angle-right arrow-animation" /></NavLink> */}
                                        </div>
                                    </div>
                                </div>
                            ))}
                                
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default OurServices3;